import * as THREE from 'three'
import Experience from './Experience.js'
import Baked from './Baked.js'
import GoogleLeds from './GoogleLeds.js'
import LoupedeckButtons from './LoupedeckButtons.js'
import CoffeeSteam from './CoffeeSteam.js'
import TopChair from './TopChair.js'
import ElgatoLight from './ElgatoLight.js'
import BouncingLogo from './BouncingLogo.js'
import ZhuyuScreen from './ZhuyuScreen.js'
import ZhuyuProps from './ZhuyuProps.js'
import ZhuyuEgg from './ZhuyuEgg.js'
import ZhuyuInteractions from './ZhuyuInteractions.js'

export default class World
{
    constructor(_options)
    {
        this.experience = new Experience()
        this.config = this.experience.config
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        // 镜像容器：原版房间整体左右翻转，让布局区别于 Bruno 原作
        this.group = new THREE.Group()
        this.group.scale.x = -1
        this.scene.add(this.group)

        this.resources.on('groupEnd', (_group) =>
        {
            if(_group.name === 'base')
            {
                this.setBaked()
                this.setGoogleLeds()
                this.setLoupedeckButtons()
                this.setCoffeeSteam()
                this.setTopChair()
                this.setElgatoLight()
                this.setBouncingLogo()
                this.setScreens()
                this.props = new ZhuyuProps()
                this.egg = new ZhuyuEgg(this.props)
                this.interactions = new ZhuyuInteractions(this.props, this.egg)

                // 镜像后三角形绕序翻转，统一双面渲染避免背面剔除
                this.group.traverse((_child) =>
                {
                    if(_child.material)
                        _child.material.side = THREE.DoubleSide
                })
            }
        })
    }

    setBaked()
    {
        this.baked = new Baked()
    }

    setGoogleLeds()
    {
        this.googleLeds = new GoogleLeds()
    }

    setLoupedeckButtons()
    {
        this.loupedeckButtons = new LoupedeckButtons()
    }

    setCoffeeSteam()
    {
        this.coffeeSteam = new CoffeeSteam()
    }

    setTopChair()
    {
        this.topChair = new TopChair()
    }

    setElgatoLight()
    {
        this.elgatoLight = new ElgatoLight()
    }

    setBouncingLogo()
    {
        this.bouncingLogo = new BouncingLogo()
    }

    setScreens()
    {
        this.pcScreen = new ZhuyuScreen(
            this.resources.items.pcScreenModel.scene.children[0],
            'mediastorm'
        )
        this.macScreen = new ZhuyuScreen(
            this.resources.items.macScreenModel.scene.children[0],
            'works'
        )
    }

    resize()
    {
    }

    update()
    {
        if(this.googleLeds)
            this.googleLeds.update()

        if(this.loupedeckButtons)
            this.loupedeckButtons.update()

        if(this.coffeeSteam)
            this.coffeeSteam.update()

        if(this.topChair)
            this.topChair.update()

        if(this.bouncingLogo)
            this.bouncingLogo.update()

        if(this.pcScreen)
            this.pcScreen.update()

        if(this.macScreen)
            this.macScreen.update()

        if(this.props)
            this.props.update()

        if(this.egg)
            this.egg.update()
    }

    destroy()
    {
    }
}